


// import React from 'react';
// import { Link } from 'react-router-dom';
// import Banner from '../../components/Banner/Banner';
// import TrendingProducts from '../../components/TrendingProducts/TrendingProducts';
// import CategoriesSection from '../../components/CategoriesSection/CategoriesSection';
// import './Home.css';

// const Home = () => {


//   return (
//     <div>  
//       <main className="home-main">
//         <Banner />

//          <TrendingProducts />
//         <div className="shop-now-container">
//           <Link to="/products" className="shop-now-btn">
//             Shop All Components
//           </Link>
//         </div>

//         <CategoriesSection />

//       </main>
//     </div>
//   );
// };

// export default Home;


import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import Banner from '../../components/Banner/Banner';
import TrendingProducts from '../../components/TrendingProducts/TrendingProducts';
import CategoriesSection from '../../components/CategoriesSection/CategoriesSection';
import './Home.css';

const Home = () => {
  const [categories, setCategories] = useState([]);
  const [designCategories, setDesignCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingDesignCategories, setLoadingDesignCategories] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Function to generate a proper URL path for a category
  const generateCategoryPath = (category) => {
    // If category already has a path, use that
    if (category.path) {
      return category.path;
    }

    // Otherwise, generate a path based on the category name
    // Convert category name to lowercase and replace spaces with hyphens
    const categorySlug = category.name
      .toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, '')     // Remove any non-alphanumeric characters except hyphens
      .replace(/-+/g, '-')            // Replace multiple hyphens with a single hyphen
      .replace(/^-|-$/g, '');         // Remove hyphens at the beginning or end

    return `/products?category=${categorySlug}`;
  };

  // Fetch regular product categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        console.log("Fetching categories for sidebar...");

        // Query for active categories, ordered by displayOrder
        const categoriesQuery = query(
          collection(db, 'categories'),
          where('active', '==', true),
          orderBy('displayOrder')
        );

        const querySnapshot = await getDocs(categoriesQuery);

        if (querySnapshot.empty) {
          console.log("No active categories found");
          setCategories([]);
          setLoading(false);
          return;
        }

        // Convert query snapshot to array of categories
        const categoriesData = querySnapshot.docs.map(doc => {
          const data = doc.data();

          // Create category object with required properties
          const category = {
            id: doc.id,
            ...data
          };

          // Generate path for this category if it doesn't have one
          category.path = generateCategoryPath(category);

          return category;
        });

        console.log("Found categories for sidebar:", categoriesData);
        setCategories(categoriesData);
      } catch (err) {
        console.error("Error fetching categories for sidebar:", err);
        // If there's an index error, fall back to a simpler query
        if (err.message.includes('requires an index')) {
          try {
            console.log("Trying fallback query without ordering...");
            const simpleQuery = query(
              collection(db, 'categories'),
              where('active', '==', true)
            );

            const snapshot = await getDocs(simpleQuery);

            if (snapshot.empty) {
              setCategories([]);
            } else {
              // Process and sort manually
              const data = snapshot.docs.map(doc => {
                const categoryData = doc.data();
                const category = {
                  id: doc.id,
                  ...categoryData
                };

                // Generate path for this category
                category.path = generateCategoryPath(category);

                return category;
              });

              // Sort by displayOrder
              const sortedData = data.sort((a, b) =>
                (a.displayOrder || 0) - (b.displayOrder || 0)
              );

              setCategories(sortedData);
            }
          } catch (fallbackErr) {
            console.error("Fallback query failed:", fallbackErr);
            setError(fallbackErr);
          }
        } else {
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Fetch design categories from designCategories collection
  useEffect(() => {
    const fetchDesignCategories = async () => {
      try {
        setLoadingDesignCategories(true);
        console.log("Fetching design categories...");

        // Query for design categories, ordered by name (matching DesignMakersHub component)
        const designCategoriesQuery = query(
          collection(db, 'designCategories'),
          orderBy('name'),
          limit(4)  // Limit to 4 categories for preview
        );

        const querySnapshot = await getDocs(designCategoriesQuery);

        if (querySnapshot.empty) {
          console.log("No design categories found");
          setDesignCategories(getDefaultDesignCategories());
        } else {
          // Convert query snapshot to array of design categories
          const designCategoriesData = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));

          console.log("Found design categories:", designCategoriesData);
          setDesignCategories(designCategoriesData);
        }
      } catch (err) {
        console.error("Error fetching design categories:", err);
        // Use default categories in case of error
        setDesignCategories(getDefaultDesignCategories());
      } finally {
        setLoadingDesignCategories(false);
      }
    };

    fetchDesignCategories();
  }, []);

  // Default design categories as fallback - matching structure from DesignMakersHub
  const getDefaultDesignCategories = () => {
    return [
      {
        id: 'fast-prototyping',
        name: 'Fast Prototyping',
        icon: '⚡',
        description: 'Quick turnaround for your prototype needs',
        slug: 'fast-prototyping'
      },
      {
        id: 'pcb-manufacturing',
        name: 'PCB Manufacturing',
        icon: '🔌',
        description: 'Professional PCB fabrication services',
        slug: 'pcb-manufacturing'
      },
      {
        id: '3d-printing',
        name: '3D Printing',
        icon: '🖨️',
        description: 'Bring your 3D designs to life',
        slug: '3d-printing'
      },
      {
        id: 'laser-cutting',
        name: 'Laser Cutting',
        icon: '✂️',
        description: 'Precision laser cutting for your projects',
        slug: 'laser-cutting'
      }
    ];
  };

  // Handle design category selection
  const handleDesignCategorySelect = (category) => {
    // Navigate to DesignMakersHub with the selected category
    const categoryId = category.slug || category.id;
    navigate(`/design-makers-hub`, { state: { selectedCategory: categoryId } });
  };

  return (
    <div>
      <main className="home-main">
        <div className="home-layout">
          {/* Sidebar with dynamically loaded categories */}
          <aside className="home-sidebar">
            <div className="sidebar-section">
              <h3> 🛠️ Categories</h3>
              {loading ? (
                <div className="sidebar-loading">Loading categories...</div>
              ) : error ? (
                <div className="sidebar-error">Error loading categories</div>
              ) : categories.length === 0 ? (
                <div className="sidebar-empty">No categories available</div>
              ) : (
                <ul>
                  {categories.map(category => (
                    <li key={category.id}>
                      <Link to={category.path}>{category.name}</Link>
                    </li>
                  ))}
                  <li><Link to="/products">View All</Link></li>
                </ul>
              )}
            </div>

            <div className="sidebar-section">
              <h3>Design Makers Hub</h3>
              {loadingDesignCategories ? (
                <div className="sidebar-loading">Loading design categories...</div>
              ) : designCategories.length === 0 ? (
                <div className="sidebar-empty">No design categories available</div>
              ) : (
                <div className="featured-design-categories">
                  {/* Show only one featured design category in sidebar */}
                  {designCategories.slice(0, 1).map(category => (
                    <div
                      key={category.id}
                      className="featured-design-item"
                      onClick={() => handleDesignCategorySelect(category)}
                    >
                      <div className="design-category-icon">{category.icon}</div>
                      <div className="design-category-info">
                        <p>{category.name}</p>
                        <small>{category.description}</small>
                      </div>
                    </div>
                  ))}
                  <Link to="/design-makers-hub" className="view-all-designs-btn">
                    View All Design Categories
                  </Link>
                </div>
              )}
            </div>
            <div className="sidebar-section">
              <h3>🚀 ProCart Student Assist</h3>
              <ul>
                <li><Link>🧠 Attractive Modals to Boost Innovation</Link></li>
                <li><Link>🔩 Buy Embedded Components Instantly</Link></li>
                <li><Link>📦 Fast Delivery Across India</Link></li>
              </ul>
            </div>
          </aside>

          {/* Main Content */}
          <div className="home-content">
            <Banner />

            <TrendingProducts />
            <div className="shop-now-container1">
              <Link to="/products" className="shop-now-btn">
                Shop All Components
              </Link>
            </div>

            {/* Display Categories Section */}
            <CategoriesSection />

            
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;